// Analytics event hooks — no-op sink today; wire up GA/Segment/etc. later.
// Usage: track("watch_now_clicked", { device: "ios" })
export function track(eventName, payload = {}) {
  try {
    if (typeof window === "undefined") return;
    // Store the last N events for debugging in the current session.
    window.__ycn_events = window.__ycn_events || [];
    window.__ycn_events.push({ eventName, payload, ts: Date.now() });
    if (window.__ycn_events.length > 200) window.__ycn_events.shift();
    // Optional custom event bus for future GA/Segment/GTM integration.
    if (typeof window.dispatchEvent === "function") {
      window.dispatchEvent(new CustomEvent("ycn:analytics", { detail: { eventName, payload } }));
    }
    // eslint-disable-next-line no-console
    if (process.env.NODE_ENV !== "production") console.debug("[ycn:analytics]", eventName, payload);
  } catch (err) {
    // fail-open; never throw from analytics — but surface the error in dev so real
    // bugs (bad payload, thrown CustomEvent listener, etc.) aren't silently swallowed.
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn("[ycn:analytics] track() failed:", eventName, err);
    }
  }
}

// Known event name constants (single source of truth)
export const EVENTS = {
  WATCH_NOW_CLICKED: "watch_now_clicked",
  APPLE_APP_STORE_CLICKED: "apple_app_store_clicked",
  WATCH_PLATFORM_MODAL_OPENED: "watch_platform_modal_opened",
  MEET_THE_FOUNDERS_CLICKED: "meet_the_founders_clicked",
};
